import {FC, useState} from 'react';
import PainelMasterPage from '../../../components/PainelMasterPage/PainelMasterPage';
import PageBase from '../../../components/PageBase/PageBase';
import {usePaginate} from '../../../providers/PaginateProvider';
import AppPagination from '../../../components/AppPagination/AppPagination';
import SkeletonTable from '../../../components/SkeletonTable/SkeletonTable';
import {useProposalsStatus} from '../../../providers/ProposalsCovenantsTable/ProposalManualStatusProvider';
import moment from 'moment';
import './ProposalsStatus.scss';
import ModalProposalStatusEdit
    from "../../../components/ProposalsTrack/ModalProposalStatusEdit/ModalProposalStatusEdit";
import ButtonEdit from "../../../components/ButtonEdit/ButtonEdit";
import ButtonDelete from "../../../components/ButtonDelete/ButtonDelete";
import {StatusManualProposalModel} from "../../../models/ProposalsTrack/StatusManualProposalModel";
import Swal from "sweetalert2";
import {ProposalSaleOriginModel} from "../../../models/ProposalsTrack/ProposalSaleOriginModel";
import {toast} from "react-toastify";

interface ProposalsStatusProps {
}

const ProposalsStatus: FC<ProposalsStatusProps> = () => {
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
    const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
    const [itemEdit, setItemEdit] = useState<StatusManualProposalModel | null>()

    const {params, setParams, proposalsStatus, isLoading, handleInative, handleList} = useProposalsStatus();
    const {pagesPaginate, handlePaginate} = usePaginate();


    const handleInativeAlert = async (item: StatusManualProposalModel) => {

        Swal.fire({
            title: "Atenção!",
            html: `Deseja realmente inativar a origem ${item.description}`,
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            showConfirmButton: true,
            showCancelButton: true,
        }).then((value) => {
            if (value.isConfirmed) {
                deleteItem(item)
            }

        })
    }

    const deleteItem = async (item: ProposalSaleOriginModel) => {
        const res = await handleInative(item?.id ?? null);
        if (!res) {
            handleList();
            toast.success(`${item.description} inativado com sucesso!`)
            return;
        }

        toast.error(res)

    }
    const renderList = () => {
        if (proposalsStatus?.length > 0) {
            return (
                <>
                    {proposalsStatus?.map((x: any) => (
                        <tr key={x.id}>
                            <td className="text-sm text-center">{x.id}</td>
                            <td className="text-sm text-wrap" style={{width: '20%'}}>{x.description}</td>
                            <td className="text-center text-sm">
                <span className={`badge`} style={{backgroundColor: x.backgroundColor, color: x.textColor}}>
                  {x.description}
                </span>
                            </td>
                            <td className="text-center text-sm">
                <span className={`badge ${!!x.deleted_at ? 'badge-danger' : 'badge-success'}`}>
                  {!!x.deleted_at ? 'Inativa' : 'Ativa'}
                </span>
                            </td>
                            <td className="text-center text-sm">{moment(x.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                            <td className='text-center text-sm'>
                                 <span className='d-flex gap-2'>
                                <ButtonEdit
                                    tooltipText="Editar"
                                    onClick={() => {
                                        setItemEdit(x);
                                        setShowModalInsert(true);
                                    }}
                                />
                                <ButtonDelete
                                    onClick={() => {
                                        handleInativeAlert(x)
                                    }}
                                    tooltipText="Inativar"/>
                                 </span>
                            </td>
                        </tr>
                    ))}
                </>
            );
        } else {
            return (<tr className='text-sm text-center'>
                <td colSpan={6}>Não há registros</td>
            </tr>);
        }
    }

    const renderContent = () => {
        return (
            <div className="table-responsive p-0">
                {isLoading ? (
                    <SkeletonTable columns={6}/>
                ) : (
                    <table className="table table-flush">
                        <thead className="thead-light">
                        <tr>
                            <th className="text-center" scope="col">#ID</th>
                            <th scope="col">NOME</th>
                            <th scope="col" className="text-center">COR</th>
                            <th scope="col" className="text-center">STATUS</th>
                            <th scope="col" className="text-center">DATA DE CADASTRO</th>
                            <th className="text-center" scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderList()}
                        </tbody>
                    </table>
                )}

                {(pagesPaginate) && (
                    <div>
                        <nav aria-label="...">
                            <AppPagination
                                pages={pagesPaginate}
                                handlePaginate={handlePaginate}
                                params={params}
                                setParams={setParams}
                            />
                        </nav>
                    </div>
                )}
            </div>
        )
    }

    return (
        <PainelMasterPage
            title='Status da Propostas'
            icon='fas fa-comments-dollar'
        >
            <div className="ProposalsStatus" data-testid="ProposalsStatus">
                <PageBase
                    content={renderContent()}
                    title={'Status da Propostas'}
                    subtitle={'Listagem de status da propostas'}
                    hasFilter={false}
                    textButtonAdd='+ Novo Status'
                    handleAdd={() => setShowModalInsert(true)}
                    handleFilter={() => setShowModalFilter(true)}
                />
            </div>

            <ModalProposalStatusEdit

                isLoading={isLoading}
                show={showModalInsert}
                onClose={() => {
                    setItemEdit(null);
                    setShowModalInsert(!showModalInsert)
                }}
                item={itemEdit}
            />
        </PainelMasterPage>
    );
}

export default ProposalsStatus;
